import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const EditCat = ({ cats, onUpdate }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    breed: '',
    color: '',
    personality: '',
    photo: ''
  });

  useEffect(() => {
    const cat = cats.find(c => c.id === id);
    if (cat) {
      setFormData({ ...cat, photo: cat.photo || '' });
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } else {
      navigate('/');
    }
  }, [id, cats, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData(current => ({
        ...current,
        photo: typeof reader.result === 'string' ? reader.result : current.photo
      }));
    };
    reader.readAsDataURL(file);
  };

  const handlePhotoClear = () => {
    setFormData(current => ({
      ...current,
      photo: ''
    }));

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.name || !formData.age || !formData.breed || !formData.color) {
      alert('Please fill in all required fields');
      return;
    }

    onUpdate(id, formData);
    navigate('/');
  };

  return (
    <div className="form-container">
      <h1>Edit Cat</h1>
      <form onSubmit={handleSubmit} className="cat-form">
        <div className="form-group">
          <label htmlFor="name">Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="age">Age (years) *</label>
          <input
            type="number"
            id="age"
            name="age"
            min="0"
            value={formData.age}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="breed">Breed *</label>
          <input
            type="text"
            id="breed"
            name="breed"
            value={formData.breed}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="color">Color *</label>
          <input
            type="text"
            id="color"
            name="color"
            value={formData.color}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="personality">Personality</label>
          <textarea
            id="personality"
            name="personality"
            value={formData.personality}
            onChange={handleChange}
            rows="4"
          />
        </div>

        <div className="form-group">
          <label htmlFor="photo">Upload Photo</label>
          <input
            type="file"
            id="photo"
            name="photo"
            accept="image/*"
            onChange={handleFileChange}
            ref={fileInputRef}
          />
          {formData.photo && (
            <div className="photo-preview">
              <img src={formData.photo} alt={`${formData.name || 'Selected'} preview`} />
              <button type="button" className="btn btn-secondary" onClick={handlePhotoClear}>
                Remove Photo
              </button>
            </div>
          )}
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary">
            Update Cat
          </button>
          <button 
            type="button" 
            className="btn btn-secondary"
            onClick={() => navigate('/')}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditCat;
